import React from 'react';
import { Link } from 'react-router-dom';

export default function AboutContact() {
    return (
        <div style={containerStyle}>
            <header style={headerStyle}>
                <h1 style={titleStyle}>Hakkımızda & İletişim</h1>
                <p style={subtitleStyle}>Sanveta Veteriner Hayvan Sağlığı ve Sanayi Ticaret Limited Şirketi</p>
            </header>

            <div style={contentLayout}>
                {/* SOL KOLON: KURUMSAL VİZYON VE DEĞERLER */}
                <section style={sectionStyle}>
                    <h2 style={sectionTitle}>Vizyon ve Değerlerimiz</h2>
                    <p style={textStyle}>
                        <strong>Sanveta Animal Healthcare</strong>, veteriner hekimliğinde kalite, güven ve yenilikçiliği ön planda tutarak geliştirilen ürünleri hayvan sağlığına kazandırmak amacıyla kurulmuş bir ekip çalışmasının ürünüdür.
                    </p>
                    <p style={textStyle}>
                        Bilimsel veriye, etik değerlere ve sürekli gelişime olan bağlılığımızla; sadece bugünün değil, yarının veteriner hekimliğine de katkı sunmayı hedefliyoruz. Sektörde güvenilir bir çözüm ortağı olarak yer almaktan gurur duyuyoruz.
                    </p>
                    
                    <div style={productHighlightBox}>
                        <h4 style={{ margin: '0 0 10px 0', color: '#2c3e50' }}>📍 Öne Çıkan Çözümlerimiz</h4>
                        <p style={productTextStyle}>
                            <strong>LACRISAN® Veteriner Göz Damlası:</strong> Evcil hayvanların göz sağlığını desteklemeye yönelik, saha hekimlerinin gerçek ihtiyaçları doğrultusunda geliştirilmiş yerli üretim çözümümüzdür.
                        </p>
                        <p style={productTextStyle}>
                            <strong>VetHelper:</strong> Klinik karar destek mekanizmalarını dijitalleştiren profesyonel yazılım platformumuzdur.
                        </p>
                    </div>
                </section>

                {/* SAĞ KOLON: KURUMSAL KİMLİK VE EKİP */}
                <section style={sectionStyle}>
                    <h2 style={sectionTitle}>Kurumsal Kimlik</h2>
                    <div style={infoBox}>
                        <h4 style={subTitleStyle}>Kurucu</h4>
                        <p style={nameStyle}>Elis Büşra Kılıç Esen</p>
                    </div>

                    <div style={infoBoxGreen}>
                        <h4 style={subTitleStyle}>Geliştirici & Danışman</h4>
                        <p style={nameStyle}>DVM, MSc. Mustafa Esen</p>
                        <span style={descStyle}>Veteriner Hekim (İç Hastalıkları Uzmanı & PhD Candidate)</span>
                    </div>

                    <div style={{ marginTop: '30px' }}>
                        <h3 style={{ fontSize: '20px', marginBottom: '15px' }}>İletişim Bilgileri</h3>
                        <div style={contactGrid}>
                            <div style={contactItem}>
                                <span style={iconStyle}>📍</span>
                                <p style={contactTextStyle}>
                                    ADALET MAH. MANAS BUL. FOLKART TOWERS B KULE KAT:34 İÇ KAPI: 3408 BAYRAKLI/İZMİR
                                </p>
                            </div>
                            <div style={contactItem}>
                                <span style={iconStyle}>📞</span>
                                <p style={contactTextStyle}>+90 541 492 02 98</p>
                            </div>
                            <div style={contactItem}>
                                <span style={iconStyle}>✉️</span>
                                <p style={contactTextStyle}>info@sanveta.com</p>
                            </div>
                            <div style={contactItem}>
                                <span style={iconStyle}>📸</span>
                                <a href="https://www.instagram.com/sanvetanimalhealthcare/" 
                                   target="_blank" rel="noreferrer" style={linkStyle}>
                                    @sanvetanimalhealthcare
                                </a>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <footer style={footerStyle}>
                <Link to="/" style={backLinkStyle}>← Ana Sayfaya Dön</Link>
            </footer>
        </div>
    );
}

// --- STİLLER (Üst Başlık Kesilmesi İçin Boşluk Artırıldı) ---
const containerStyle = { 
    padding: '30px 15px 50px 15px', 
    maxWidth: '1200px', 
    margin: '0 auto', 
    fontFamily: "'Segoe UI', Roboto, sans-serif", 
    color: '#2c3e50', 
    lineHeight: '1.6',
    boxSizing: 'border-box',
    width: '100%',
    paddingTop: 'max(60px, env(safe-area-inset-top))' // Menünün altında kalmaması için net güvenlik payı
};

const headerStyle = { textAlign: 'center', marginBottom: '35px' };
const titleStyle = { fontSize: '28px', fontWeight: 'bold', color: '#1a252f', marginBottom: '10px', wordBreak: 'break-word' };
const subtitleStyle = { color: '#3498db', fontSize: '15px', fontWeight: '500' };
const contentLayout = { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '20px' };
const sectionStyle = { background: '#fff', padding: '20px', borderRadius: '20px', boxShadow: '0 10px 40px rgba(0,0,0,0.05)', border: '1px solid #f0f0f0', boxSizing: 'border-box' };
const sectionTitle = { borderBottom: '3px solid #3498db', paddingBottom: '10px', marginBottom: '20px', fontSize: '20px' };
const textStyle = { fontSize: '15px', marginBottom: '15px', color: '#455a64' };
const productHighlightBox = { marginTop: '25px', padding: '15px', background: '#e8f4fd', borderRadius: '15px', borderLeft: '5px solid #3498db' };
const productTextStyle = { fontSize: '14px', margin: '0 0 10px 0', color: '#34495e' };
const infoBox = { padding: '15px', background: '#f8f9fa', borderRadius: '12px', borderLeft: '5px solid #3498db', marginBottom: '15px' };
const infoBoxGreen = { padding: '15px', background: '#f8f9fa', borderRadius: '12px', borderLeft: '5px solid #2ecc71' };
const subTitleStyle = { margin: '0 0 5px 0', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '1px', color: '#7f8c8d' };
const nameStyle = { margin: '0', fontSize: '16px', fontWeight: 'bold', color: '#2c3e50' };
const descStyle = { fontSize: '13px', color: '#7f8c8d' };
const contactGrid = { display: 'flex', flexDirection: 'column', gap: '15px' };
const contactItem = { display: 'flex', gap: '12px', alignItems: 'flex-start' };
const iconStyle = { fontSize: '16px', background: '#f0f3f5', padding: '8px', borderRadius: '8px', minWidth: '30px', textAlign: 'center' };
const contactTextStyle = { margin: '0', fontSize: '14px', color: '#455a64', wordBreak: 'break-word' };
const linkStyle = { color: '#3498db', textDecoration: 'none', fontWeight: '500', fontSize: '14px', wordBreak: 'break-all' };
const footerStyle = { textAlign: 'center', marginTop: '40px' };
const backLinkStyle = { color: '#95a5a6', textDecoration: 'none', fontWeight: 'bold' };